module.exports = __webpack_public_path__ + "b4cb551ed48304aacebf5e1d19aee901.pdf";